import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
(function () {
  if (typeof document === "undefined") {
    return;
  }
  const styles = ".kof-button {\n  height: 32px;\n  padding: 0 8px;\n  border: 1px solid;\n  border-radius: 2px;\n  display: flex;\n  align-items: center;\n}\n.kof-button:hover {\n  cursor: pointer;\n}\n.kof-button[disabled]:hover {\n  cursor: initial;\n}\n.kof-button.primary {\n  background: #1269B0;\n  border-color: #1269B0;\n  color: white;\n}\n.kof-button.primary[disabled] {\n  opacity: 0.5;\n}\n.kof-button.primary:hover {\n  background: #2691e9;\n  border-color: #2691e9;\n}\n.kof-button.primary[disabled]:hover {\n  background: #1269B0;\n  border-color: #1269B0;\n}\n.kof-button.secondary {\n  background: white;\n  border-color: #767676;\n}\n.kof-button.secondary:hover {\n  background: #fafafa;\n}\n.kof-button.secondary[disabled] {\n  color: #7e8b98;\n  border-color: gainsboro;\n}\n.kof-button.secondary[disabled]:hover {\n  background: white;\n}";
  const fileName = "Button_Button_e75bbba7-19d4-401b-898f-3158b4346ef8";
  const element = document.querySelector("style[data-sass-component='Button_Button_e75bbba7-19d4-401b-898f-3158b4346ef8']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
function Button(props) {
  const classes = ['kof-button', props.type ? props.type : 'primary', props.className];
  return /*#__PURE__*/_jsx("button", {
    className: classes.join(' '),
    onClick: !props.disabled ? props.onClick : null,
    disabled: props.disabled,
    children: props.children
  });
}
Button.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  className: PropTypes.string
};
export { Button };